import React, { useState } from "react";
import { Cookie } from "lucide-react";
import { getConsent, setConsent } from "../lib/analytics";

export default function CookieConsent() {
  const [open, setOpen] = useState(() => !getConsent());
  if (!open) return null;
  const decide = (granted) => { setConsent(granted); setOpen(false); };
  return (
    <div data-testid="cookie-consent" className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-sm z-[90] rounded-2xl bg-white shadow-2xl ring-1 ring-slate-200 p-4 sm:p-5 float-up">
      <div className="flex gap-3">
        <span className="shrink-0 h-9 w-9 rounded-xl bg-[#F4F5FF] text-[#4A3BFA] grid place-items-center"><Cookie size={18} /></span>
        <div className="min-w-0">
          <p className="text-[13.5px] font-semibold text-slate-900">Cookies e privacidade</p>
          <p className="mt-1 text-[12.5px] leading-relaxed text-slate-600">
            Usamos cookies essenciais para o Basiq funcionar e, com sua permissão, o Google Analytics para entender como você usa o site. Nenhum dado é vendido. Você pode mudar isso a qualquer momento.
          </p>
          <div className="mt-3 flex items-center gap-2">
            <button type="button" onClick={() => decide(true)} data-testid="consent-accept" className="h-9 px-4 rounded-full bg-slate-900 text-white text-[12.5px] font-semibold hover:bg-slate-800 transition-colors">Aceitar</button>
            <button type="button" onClick={() => decide(false)} data-testid="consent-essential" className="h-9 px-4 rounded-full text-[12.5px] font-medium text-slate-700 ring-1 ring-slate-200 hover:bg-slate-50 transition-colors">Só essenciais</button>
          </div>
        </div>
      </div>
    </div>
  );
}
